import type { WizardStepId } from './stayForm';

export interface StayPublishProblem {
  code: string;
  message: string;
}

/** Which wizard step fixes each publish problem code (backend `stayPublishProblems`). */
export const PROBLEM_STEP: Record<string, WizardStepId> = {
  photos: 'photos',
  title: 'title',
  description: 'description',
  location: 'location',
  timezone: 'location',
  rooms: 'basics',
  price: 'price',
  cancellation_policy: 'cancellation',
  non_refundable_discount: 'cancellation',
  check_in_times: 'check-in',
};

/** The first GraphQL error of an Apollo error, as the API sent it. */
export function firstGraphQLError(
  error: unknown,
): { message?: string; extensions?: any } | undefined {
  const e = error as { graphQLErrors?: { message?: string; extensions?: any }[] } | undefined;
  return e?.graphQLErrors?.[0];
}

/** `STAY_NOT_PUBLISHABLE` carries the list of problems in `extensions.details.problems`. */
export function publishProblemsOf(error: unknown): StayPublishProblem[] {
  const gqlError = firstGraphQLError(error);
  if (gqlError?.extensions?.code !== 'STAY_NOT_PUBLISHABLE') return [];
  const problems = gqlError.extensions?.details?.problems;
  return Array.isArray(problems) ? problems : [];
}

/** A message for the host: the API's own words when it sent any. */
export function stayErrorMessage(
  error: unknown,
  fallback = 'Something went wrong. Try again.',
): string {
  const gqlError = firstGraphQLError(error);
  const message =
    gqlError?.extensions?.originalError?.message ??
    gqlError?.message ??
    (error as { message?: string } | undefined)?.message;
  if (Array.isArray(message)) return message.join('. ');
  return typeof message === 'string' && message.trim() ? message : fallback;
}
